// Re-autenticación con huella antes de mover plata (step-up).
// El backend responde 428 {code:'step_up_required'} → acá se pide la huella y se
// reintenta la MISMA request con la autorización adentro. El usuario no tiene que
// volver a apretar Confirmar. Ver backend: routes/passkeys.py (consumir_step_up)
import axios from 'axios';
import { toast } from 'sonner';
import { usarPasskey, errorPasskey } from './webauthn';

const esStepUp = (error) => {
  const d = error?.response?.data?.detail;
  return error?.response?.status === 428 && d?.code === 'step_up_required';
};

const sinPasskey = (error) => {
  const d = error?.response?.data?.detail;
  return error?.response?.status === 428 && d?.code === 'sin_passkey';
};

const pedirAutorizacion = async (API) => {
  const auth = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
  const { data: o } = await axios.post(`${API}/passkeys/stepup/options`, {}, auth);
  const credential = await usarPasskey(o.options);
  const { data } = await axios.post(`${API}/passkeys/stepup/verify`,
    { token: o.token, credential }, auth);
  return data.step_up_token;
};

// Para los flujos que usan fetch() y no pasan por el interceptor de axios
// (ej: OneTouchPayCashoutModal). Devuelve la autorización o tira el error.
export const obtenerAutorizacionHuella = pedirAutorizacion;

export const instalarStepUp = (API) => axios.interceptors.response.use(
  (r) => r,
  async (error) => {
    if (sinPasskey(error)) {
      toast.error('Este dispositivo no tiene huella registrada. Registralo en Seguridad.');
      return Promise.reject(error);
    }
    const cfg = error?.config;
    if (!esStepUp(error) || !cfg || cfg._stepUpIntentado) return Promise.reject(error);
    cfg._stepUpIntentado = true;

    const t = toast.loading('Confirmá la operación con tu huella');
    let autorizacion;
    try {
      autorizacion = await pedirAutorizacion(API);
    } catch (e) {
      toast.dismiss(t);
      toast.error(e?.response ? (e.response.data?.detail?.message
        || e.response.data?.detail || 'No se pudo verificar la huella') : errorPasskey(e));
      return Promise.reject(error);
    }
    toast.dismiss(t);

    let body = {};
    try { body = cfg.data ? JSON.parse(cfg.data) : {}; } catch { body = {}; }
    cfg.data = JSON.stringify({ ...body, step_up_token: autorizacion });
    return axios(cfg);
  },
);
